import GetUIAssets from '@/graphql/GetUIAssets.gql'
import UpdateLogo from '@/graphql/UpdateLogo.gql'
import UpdateFavicon from '@/graphql/UpdateFavicon.gql'
import UpdateColors from '@/graphql/UpdateColors.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getUIAssets ({ dispatch, commit }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetUIAssets,
        fetchPolicy: 'no-cache'
      })
      return response.data.getUIAssets
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async updateLogo ({ dispatch, commit }, { logoBase64, logoLink }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateLogo,
        fetchPolicy: 'no-cache',
        variables: {
          logoBase64,
          logoLink
        }
      })
      return response.data.updateLogo
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async updateFavicon ({ dispatch, commit }, { faviconBase64 }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateFavicon,
        fetchPolicy: 'no-cache',
        variables: {
          faviconBase64
        }
      })
      return response.data.updateFavicon
    } catch (err) {
      dispatch('showError', err)
    }
  },
  async updateColors ({ dispatch, commit }, { colors }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateColors,
        fetchPolicy: 'no-cache',
        variables: {
          colors
        }
      })
      return response.data.updateColors
    } catch (err) {
      dispatch('showError', err)
    }
  }
}
